module.exports = __webpack_public_path__ + "img/Strip-Front-B10-Jb.fd186f1a.png";